import React, { useState, memo } from 'react';
import { CheckIcon, StarIcon as StarIconLucide, ClockIcon, RocketIcon, ChevronLeftIcon, ChevronRightIcon, XIcon } from 'lucide-react';
import { CopiesAvailableCounter } from './CopiesAvailableCounter';
export const PricingSection = () => {
  const [hoveredBadge, setHoveredBadge] = useState(null);
  const [collectorBundleImageIndex, setCollectorBundleImageIndex] = useState(0);
  const [enlargedImage, setEnlargedImage] = useState(null);
  const collectorBundleImages = ['https://uploadthingy.s3.us-west-1.amazonaws.com/ucTh24qJQz1i6rVWh5876N/TIME_TRAVELLERS_COLLECTOR_BUNDLEC.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/i3DKchuX8RMmzYrqAhpK13/foam-trucker-hat-black-one-size-right-front-6914c3a4781f3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/rbwPKtwrCHTaFNqFeaH2fA/enhanced-matte-paper-framed-poster-%28in%29-white-10x10-front-6914bc8d8b378.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/2eQBo88LwYLe7TLxEHMDQe/white-glossy-mug-white-11-oz-handle-on-left-6914d9d1888e4.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dsPxuWW7a4Xja3nWKMPU8M/all-over-print-tote-bag-yellow-15x15-mockup-69123afa061d2.jpg'];
  const nextCollectorImage = () => {
    setCollectorBundleImageIndex(prev => prev === collectorBundleImages.length - 1 ? 0 : prev + 1);
  };
  const prevCollectorImage = () => {
    setCollectorBundleImageIndex(prev => prev === 0 ? collectorBundleImages.length - 1 : prev - 1);
  };
  const handleImageClick = (index: number) => {
    if (index !== 0) {
      setEnlargedImage(collectorBundleImages[index]);
    }
  };
  const handleMainImageClick = (imageUrl: string) => {
    setEnlargedImage(imageUrl);
  };
  const closeEnlargedImage = () => {
    setEnlargedImage(null);
  };
  const editions = [{
    image: 'https://cdn.magicpatterns.com/uploads/j6sRyAvruZXTeVPPgt2ZXq/BACK_IN_TIME_-_DIGITAL11v2.png',
    name: 'Digital Edition',
    emoji: '📖',
    originalPrice: '$47.97',
    currentPrice: '$29.97',
    features: ['Back In Time - 40th Anniversary Collectors Edition (1985-2025) | Digital PDF ', 'Instant Download'],
    cta: '📖 Get Digital Edition',
    purchaseUrl: 'https://legendaryreads.com/cart/42185022439506:1',
    popular: false,
    borderColor: 'border-christmas-gold/30',
    hoverBorderColor: 'hover:border-christmas-gold',
    shadow: 'hover:shadow-christmas-glow',
    ctaClass: 'bg-gradient-to-r from-christmas-gold to-orange-500 hover:from-orange-500 hover:to-christmas-gold text-black shadow-christmas-glow hover:shadow-[0_0_30px_rgba(255,215,0,0.8)] border-2 border-christmas-gold/50',
    badge: {
      text: '🎁 INSTANT ACCESS',
      tooltip: 'Download Immediately',
      gradient: 'bg-gradient-to-r from-christmas-gold to-orange-500',
      textColor: 'text-black',
      glow: 'shadow-christmas-glow'
    }
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/rzSr3GLdz6hS4hx7t1NZT4/Holiday_Edition_Digital_Set.png',
    name: 'Holiday Edition Digital Set',
    emoji: '🎄',
    originalPrice: '$119.97',
    currentPrice: '$69.97',
    features: ['Back In Time - 40th Anniversary Collectors Edition (1985-2025) | Digital', 'Special Supplement #1: BEHIND THE CLOCK TOWER: Stories From The Set | Digital', 'Special Supplement #2: GREAT SCOTT! 40 Quotes For 40 Years | Digital', 'Special Supplement #3: TIME IMAGINATION DESTINY: The Philosophical And Cultural Legacy Of Btf | Digital', 'Instant Download'],
    cta: '🎄 Get Holiday Edition Digital Set',
    purchaseUrl: 'https://legendaryreads.com/cart/42231842701394:1',
    popular: true,
    borderColor: 'border-christmas-green',
    hoverBorderColor: 'hover:border-christmas-green',
    shadow: 'hover:shadow-[0_0_30px_rgba(34,197,94,0.8)]',
    ctaClass: 'relative bg-gradient-to-r from-green-500 via-emerald-500 to-green-600 hover:from-green-600 hover:via-emerald-600 hover:to-green-700 text-white font-extrabold text-lg shadow-[0_0_30px_rgba(34,197,94,0.7),0_0_60px_rgba(34,197,94,0.4)] hover:shadow-[0_0_50px_rgba(34,197,94,0.9),0_0_80px_rgba(34,197,94,0.6)] border-2 border-green-400/70 transform hover:scale-105 transition-all duration-300 before:absolute before:inset-0 before:bg-gradient-to-r before:from-green-400/20 before:via-emerald-400/30 before:to-green-400/20 before:blur-xl before:-z-10 before:animate-pulse',
    badge: {
      text: '⭐ MOST POPULAR',
      tooltip: 'Most Popular Choice',
      gradient: 'bg-gradient-to-r from-green-500 to-emerald-600',
      textColor: 'text-white',
      glow: 'shadow-[0_0_20px_rgba(34,197,94,0.6)]'
    }
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pSD1kcciQ8RbkUdnckm8uJ/PREMIUM_EDITION_V1.2.png',
    name: 'Premium Hardcover',
    emoji: '⭐',
    originalPrice: '$127.97',
    currentPrice: '$94.97',
    features: ['Back In Time - 40th Anniversary Collectors Edition (1985-2025) | Premium Hardcover Book', 'Special Supplement #1: BEHIND THE CLOCK TOWER: Stories From The Set | Digital', 'Special Supplement #2: GREAT SCOTT! 40 Quotes For 40 Years | Digital', 'Special Supplement #3: TIME IMAGINATION DESTINY: The Philosophical And Cultural Legacy Of Btf | Digital', 'Delivers in 14 days'],
    cta: '⭐ Get Premium Edition',
    purchaseUrl: 'https://legendaryreads.com/cart/42193918787666:1',
    popular: false,
    borderColor: 'border-christmas-red/30',
    hoverBorderColor: 'hover:border-christmas-red',
    shadow: 'hover:shadow-[0_0_20px_rgba(196,30,58,0.6)]',
    ctaClass: 'bg-gradient-christmas hover:opacity-90 text-white shadow-christmas-glow hover:shadow-[0_0_30px_rgba(196,30,58,0.8)] border-2 border-christmas-gold/50',
    badge: {
      text: '🎅 GREAT VALUE',
      tooltip: 'Best Christmas Gift',
      gradient: 'bg-gradient-christmas',
      textColor: 'text-white',
      glow: 'shadow-christmas-glow'
    }
  }, {
    image: collectorBundleImages[collectorBundleImageIndex],
    name: "Time Traveler's Collector Bundle",
    emoji: '🎁',
    originalPrice: '$419.97',
    currentPrice: '$249.97',
    features: ['Back In Time - 40th Anniversary Collectors Edition (1985-2025) | Premium Hardcover Book', 'Special Supplement #1: BEHIND THE CLOCK TOWER: Stories From The Set | Digital', 'Special Supplement #2: GREAT SCOTT! 40 Quotes For 40 Years | Digital', 'Special Supplement #3: TIME IMAGINATION DESTINY: The Philosophical And Cultural Legacy Of Btf | Digital', 'Back In Time Audiobook Experience', 'Hill Valley 1985, Limited, Vintage, Trucker, Hat',, "Flux Energy Core Collector's Framed Print | 10×10 Limited Edition", 'Time Machine Heritage Tote | Back In Time Edition', '40 Years Travelling Through Time Commemorative Gloss Black Mug', 'Priority Shipping'],
    cta: '🎁 Get Ultimate Christmas Bundle',
    purchaseUrl: 'https://legendaryreads.com/cart/42193919049810:1',
    popular: false,
    borderColor: 'border-christmas-gold/30',
    hoverBorderColor: 'hover:border-christmas-gold',
    shadow: 'hover:shadow-christmas-glow',
    ctaClass: 'bg-gradient-festive hover:opacity-90 text-white shadow-christmas-glow hover:shadow-[0_0_30px_rgba(255,215,0,0.8)] border-2 border-christmas-gold/50',
    badge: {
      text: "🎄 ULTIMATE COLLECTOR'S EDITION",
      tooltip: 'Complete Holiday Package',
      gradient: 'bg-gradient-festive',
      textColor: 'text-white',
      glow: 'shadow-christmas-glow'
    },
    hasCarousel: true
  }];
  return <section className="py-6 md:py-8 bg-gradient-to-b from-christmas-green/10 via-bttf-bg to-christmas-red/10 border-t border-b border-christmas-gold/20 relative overflow-hidden" id="pricing" data-id="element-310">
      {/* Festive Background */}
      <div className="absolute top-10 left-10 text-4xl opacity-10 animate-float" data-id="element-311">
        🎄
      </div>
      <div className="absolute top-20 right-20 text-4xl opacity-10 animate-float" style={{
      animationDelay: '1s'
    }} data-id="element-312">
        ⛄
      </div>
      <div className="absolute bottom-20 left-1/4 text-3xl opacity-10 animate-float" style={{
      animationDelay: '2s'
    }} data-id="element-313">
        🎁
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-314">
        <div className="text-center mb-6" data-id="element-315">
          <div className="flex justify-center mb-2 gap-2" data-id="element-316">
            <span className="text-3xl animate-twinkle" data-id="element-317">🎄</span>
            <StarIcon className="h-8 w-8 text-christmas-gold fill-current shadow-christmas-glow" data-id="element-318" />
            <span className="text-3xl animate-twinkle" style={{
            animationDelay: '1s'
          }} data-id="element-319">
              🎄
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-festive text-transparent bg-clip-text mb-2" data-id="element-320">
            Special 40th Anniversary Collector's Offer
          </h2>
          <div className="w-20 h-1 bg-gradient-christmas mx-auto mb-3" data-id="element-321"></div>
          <CopiesAvailableCounter data-id="element-322" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-323">
          {editions.map((edition, index) => <div key={index} className={`bg-bttf-bg/80 rounded-lg shadow-lg overflow-visible border-2 ${edition.borderColor} ${edition.hoverBorderColor} backdrop-blur-sm ${edition.shadow} transition-all duration-300 relative pt-8 ${edition.popular ? 'animate-neon-pulse-green' : ''}`} data-id="element-324">
              {/* Badge */}
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10" onMouseEnter={() => setHoveredBadge(index)} onMouseLeave={() => setHoveredBadge(null)} data-id="element-325">
                <div className="relative group" data-id="element-326">
                  <div className={`plan-badge flex items-center gap-1.5 px-5 py-3 rounded-full ${edition.badge.gradient} ${edition.badge.textColor} ${edition.badge.glow} font-medium text-xs md:text-sm uppercase tracking-wider transition-all duration-150 ${hoveredBadge === index ? 'scale-102' : 'scale-100'} border border-white/20`} style={{
                letterSpacing: '0.02em'
              }} aria-label={edition.badge.text} data-id="element-327">
                    {edition.badge.icon}
                    <span className="whitespace-nowrap" data-id="element-328">
                      {edition.badge.text}
                    </span>
                  </div>
                  {hoveredBadge === index && <div className="absolute top-full mt-2 left-1/2 transform -translate-x-1/2 bg-bttf-bg/95 border border-christmas-gold/40 rounded-md px-3 py-1.5 text-xs text-bttf-text whitespace-nowrap shadow-christmas-glow backdrop-blur-sm" data-id="element-329">
                      {edition.badge.tooltip}
                      <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-bttf-bg/95 border-t border-l border-christmas-gold/40 rotate-45" data-id="element-330"></div>
                    </div>}
                </div>
              </div>
              <div className="p-6" data-id="element-331">
                {/* Image with optional carousel */}
                <div className="flex justify-center mb-6 relative" data-id="element-332">
                  {edition.hasCarousel ? <div className="relative w-full max-w-[224px] group" data-id="element-333">
                      <div className={`aspect-square w-full rounded-lg overflow-hidden border-2 border-christmas-gold/30 ${collectorBundleImageIndex !== 0 ? 'cursor-pointer' : ''}`} onClick={() => handleImageClick(collectorBundleImageIndex)} data-id="element-334">
                        <img src={edition.image} alt={`${edition.name} - Item ${collectorBundleImageIndex + 1}`} className="w-full h-full object-cover transition-opacity duration-300 hover:opacity-90" data-id="element-335" />
                      </div>
                      <button onClick={prevCollectorImage} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 bg-gradient-christmas hover:opacity-90 text-white p-2 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10 border border-christmas-gold/50" aria-label="Previous item" data-id="element-336">
                        <ChevronLeftIcon className="h-4 w-4" data-id="element-337" />
                      </button>
                      <button onClick={nextCollectorImage} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 bg-gradient-christmas hover:opacity-90 text-white p-2 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10 border border-christmas-gold/50" aria-label="Next item" data-id="element-338">
                        <ChevronRightIcon className="h-4 w-4" data-id="element-339" />
                      </button>
                      <div className="flex justify-center gap-1.5 mt-3" data-id="element-340">
                        {collectorBundleImages.map((_, imgIndex) => <button key={imgIndex} onClick={() => setCollectorBundleImageIndex(imgIndex)} className={`w-2 h-2 rounded-full transition-all duration-300 ${imgIndex === collectorBundleImageIndex ? 'bg-christmas-gold shadow-christmas-glow w-4' : 'bg-bttf-subtext/50 hover:bg-bttf-subtext'}`} aria-label={`Go to item ${imgIndex + 1}`} data-id="element-341" />)}
                      </div>
                    </div> : <div className="w-full max-w-[224px]" data-id="element-342">
                      <div className="aspect-square w-full rounded-lg overflow-hidden cursor-pointer hover:opacity-90 transition-opacity duration-300 border-2 border-christmas-gold/30" onClick={() => handleMainImageClick(edition.image)} data-id="element-343">
                        <img src={edition.image} alt={edition.name} className="w-full h-full object-cover" data-id="element-344" />
                      </div>
                    </div>}
                </div>
                <div className="text-center mb-6" data-id="element-345">
                  <h3 className="text-xl font-bold text-bttf-text font-future flex items-center justify-center gap-2" data-id="element-346">
                    <span className="text-2xl" data-id="element-347">{edition.emoji}</span>
                    {edition.name}
                  </h3>
                  <div className="mt-2" data-id="element-348">
                    <span className="text-bttf-subtext line-through text-lg" data-id="element-349">
                      {edition.originalPrice}
                    </span>
                    <span className="text-christmas-gold font-bold text-2xl ml-2" data-id="element-350">
                      {edition.currentPrice}
                    </span>
                  </div>

                  {/* Shipping Badge */}
                  <div className="mt-4" data-id="element-351">
                    {index === 0 && <div className="inline-block bg-gradient-to-r from-christmas-gold to-orange-500 text-black font-bold px-6 py-3 rounded-lg shadow-christmas-glow animate-pulse border-2 border-christmas-gold/50" data-id="element-352">
                        <span className="text-lg tracking-wide" data-id="element-353">
                          ⚡ INSTANT ACCESS
                        </span>
                      </div>}
                    {index === 1 && <div className="inline-block bg-gradient-to-r from-christmas-green to-green-600 text-white font-bold px-6 py-3 rounded-lg shadow-[0_0_20px_rgba(22,91,51,0.6)] animate-pulse border-2 border-christmas-green/50" data-id="element-354">
                        <span className="text-lg tracking-wide" data-id="element-355">
                          🎄 INSTANT DOWNLOAD
                        </span>
                      </div>}
                    {index === 2 && <div className="inline-block bg-gradient-christmas text-white font-bold px-6 py-3 rounded-lg shadow-christmas-glow animate-pulse border-2 border-christmas-gold/50" data-id="element-356">
                        <span className="text-lg tracking-wide" data-id="element-357">
                          🎁 FREE SHIPPING
                        </span>
                      </div>}
                    {index === 3 && <div className="inline-block bg-gradient-festive text-white font-bold px-6 py-3 rounded-lg shadow-christmas-glow animate-pulse border-2 border-christmas-gold/50" data-id="element-358">
                        <span className="text-lg tracking-wide" data-id="element-359">
                          🎅 PRIORITY SHIPPING
                        </span>
                      </div>}
                  </div>
                </div>
                <ul className="mb-6" data-id="element-360">
                  {edition.features.map((feature, i) => <li key={i} className="flex items-start mb-2 text-bttf-subtext" data-id="element-361">
                      <CheckIcon className="h-5 w-5 text-christmas-gold mr-2 mt-0.5 flex-shrink-0" data-id="element-362" />
                      <span data-id="element-363">{feature}</span>
                    </li>)}
                </ul>
                <a href={edition.purchaseUrl} className={`block text-center py-3 rounded-md font-bold transition-all ${edition.ctaClass} transform hover:scale-105 ${edition.popular ? 'relative overflow-visible' : ''}`} data-id="element-364">
                  {edition.popular && <span className="absolute inset-0 bg-gradient-to-r from-green-400/30 via-emerald-400/40 to-green-400/30 blur-2xl -z-10 animate-pulse" data-id="element-365"></span>}
                  {edition.cta}
                </a>
              </div>
            </div>)}
        </div>
      </div>
      {/* Image Enlargement Modal */}
      {enlargedImage && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4" onClick={closeEnlargedImage} data-id="element-366">
          <button onClick={closeEnlargedImage} className="absolute top-4 right-4 text-bttf-text hover:text-christmas-gold transition-colors bg-bttf-bg/50 rounded-full p-2 hover:bg-bttf-bg/80" aria-label="Close enlarged image" data-id="element-367">
            <XIcon className="h-8 w-8" data-id="element-368" />
          </button>
          <div className="relative max-w-4xl max-h-[90vh] w-full" data-id="element-369">
            <img src={enlargedImage} alt="Enlarged view" className="w-full h-full object-contain rounded-lg" onClick={e => e.stopPropagation()} data-id="element-370" />
          </div>
        </div>}
    </section>;
};
const StarIcon = ({
  className
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-371">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-372"></polygon>
  </svg>;